module.exports = __webpack_public_path__ + "static/robin_kidderminster-d384e9f5cc491b7e32a86f8bf6f3c017.png";